import * as React from "react";
import { ArrowDown, ArrowUp } from "../../../assets/icons";
import { formatMoney } from "../../../utils";

export interface ListInfoCardProps {
  title: string;
  mobileTitle?: string;
  value: string | number;
  percentageChange: string | number;
  className?: string; // Adding optional className prop
  bgColor: string;
  previousDateRange?: string; // Optional prop for previous date range
  dateRange?: string; // Optional prop for previous date range
  isCashBalance?: boolean; // Optional prop to check if it's cash balance
  currency?: string; // Optional prop for currency formatting
}

const ListInfoCard: React.FC<ListInfoCardProps> = ({
  title,
  mobileTitle,
  value,
  bgColor,
  className = "",
  percentageChange,
  previousDateRange,
  dateRange,
  isCashBalance = false,
  currency,
}) => {
  const isUptrend = Number(percentageChange) >= 0;
  const showArrow = Number(percentageChange) !== 0;
  return (
    <div
      style={{ background: bgColor }}
      className={` pl-3 pt-4 md:pt-5 md:pl-4 rounded-lg md:rounded-2xl h-[78px] md:h-[150px]  bg-[]  ${className}`}
    >
      <p className="hidden md:block text-[16px] text-[#667085] font-medium leading-6 lg:mt-[20px] mb-3">
        {title}
      </p>
      <p className="md:hidden text-[14px] leading-5 font-medium text-[#000000]">
        {mobileTitle}
      </p>
      <div className="flex items-center relative group cursor-pointer">
        <p
          className={`text-[16px] md:text-[19px] lg:text-[22px] leading-6 md:leading-8 text-[#000] md:text-[#212121] font-semibold mt-1`}
        >
          {value || "--"}
        </p>
        {showArrow && (
          <div className="flex items-center justify-between gap-1 mt-1">
            <p className="text-[20px] 1220:text-[16px] xl:text-[20px] text-[#000000] font-semibold leading-6">
              {Number(value) !== 0 && showArrow && (
                <div className="flex items-center gap-1">
                  <div
                    className={` p-1 flex rounded-[4px] gap-1 items-center ${
                      isUptrend ? "" : ""
                    }`}
                  >
                    {isUptrend ? <ArrowUp /> : <ArrowDown />}
                    <h1
                      className={`text-[14px] font-semibold 1220:text-[16px] xl:text-[16px] ${isUptrend ? "text-[#37C89A]" : "text-[#D82020]"}`}
                    >
                      {percentageChange}%
                    </h1>
                  </div>
                </div>
              )}
            </p>
          </div>
        )}

        {previousDateRange && (
          <div className="absolute -bottom-[80px] md:-bottom-[70px] min-w-[319px] md:-right-[150px] -right-[200px] transform -translate-x-1/2 mb-2 hidden group-hover:flex flex-col px-5 py-3 gap-3 bg-white text-white border text-sm rounded-lg shadow-lg whitespace-nowrap z-50">
            <h6 className="text-[#98A2B3] font-medium text-sm tracking-wide text-center">
              {dateRange} vs {previousDateRange}
            </h6>
            <div className="flex justify-between items-center gap-x-10">
              <p className="text-[#667085] font-medium text-[14px] ">{title}</p>
              <p className="text-[#1D2939] flex items-center font-medium text-[14px]">
                <span>
                  {value == 0
                    ? "--"
                    : isCashBalance
                      ? formatMoney(Number(value), currency)
                      : value}
                </span>{" "}
                <span>
                  {Number(value) !== 0 && showArrow && (
                    <div className="flex items-center gap-1">
                      <div
                        className={` p-1 flex rounded-[4px] gap-1 items-center ${
                          isUptrend ? "" : ""
                        }`}
                      >
                        {isUptrend ? <ArrowUp /> : <ArrowDown />}
                        <h1
                          className={`text-[14px] font-medium ${isUptrend ? "text-[#37C89A]" : "text-[#D82020]"}`}
                        >
                          {percentageChange}%
                        </h1>
                      </div>
                    </div>
                  )}
                </span>
              </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export { ListInfoCard };
